module.exports = __webpack_public_path__ + "static/media/YM75_4.f0b5f57a.jpg";